import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function CandidateTags({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.CompanyManagement.CandidateTags.tagName'
      ),
      field: 'name',
      sortable: true,
    },
    {
      name: t('common.sortOrder'),
      field: 'sortOrder',
      sortable: true,
    },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="CandidateTag"
      getDataHandler={AdminService.getCandidateTags}
      deleteDataHandler={AdminService.deleteCandidateTag}
      createDataHandler={AdminService.createCandidateTag}
      updateDataHandler={AdminService.updateCandidateTag}
      viewLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.CompanyManagement.CandidateTags.tagName'
          ),
          field: 'name',
        },
      ]}
      viewRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: t(
            'dashboardComponents.Console.CompanyManagement.CandidateTags.tagName'
          ),
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.CandidateTags.tagNamePlaceholder'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.CandidateTags.sortOrderPlaceholder'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.CompanyManagement.CandidateTags.notesPlaceholder'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
